export var PromocodeStatusEnum;
(function (PromocodeStatusEnum) {
    PromocodeStatusEnum["Undefined"] = "UNDEFINED";
    PromocodeStatusEnum["Unused"] = "UNUSED";
    PromocodeStatusEnum["Active"] = "ACTIVE";
    PromocodeStatusEnum["Completed"] = "COMPLETED";
})(PromocodeStatusEnum || (PromocodeStatusEnum = {}));
